import styles from '../styles.module.scss';
import TemperatureIcon from '../../../assets/icons/metrics/metric-temperature.png';
import DewDurationIcon from '../../../assets/icons/metrics/metric-dew-duration.png';
import DewIcon from '../../../assets/icons/metrics/metric-dew.png';
import HumidityIcon from '../../../assets/icons/metrics/metric-humidity.png';
import GddIcon from '../../../assets/icons/metrics/metric-gdd.png';
import NdviIcon from '../../../assets/icons/metrics/metric-ndvi.png';

import SoilNdviIcon from '../../../assets/icons/metrics/metric-soil-ndvi.png';
import LeafAreaIcon from '../../../assets/icons/metrics/metric-leaf-area.png';
import PhotoNdviIcon from '../../../assets/icons/metrics/metric-photo-ndvi.png';

import { getMetricsLabels } from '../../../utils/metrics';

export const GetMetricsColumns = (t) => {
  const MetricsLabels = getMetricsLabels(t);
  return [
    {
      title: () => <span className={styles.metricsTh}>{MetricsLabels.device}</span>,
      dataIndex: 'device',
      key: 'device',
      className: styles.metricsTd,
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={TemperatureIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.temperature}
        </span>
      ),
      dataIndex: 'temperature',
      key: 'temperature',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={GddIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.gdd}
        </span>
      ),
      dataIndex: 'gdd',
      key: 'gdd',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={DewDurationIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.dewfallDuration}
        </span>
      ),
      dataIndex: 'dewDuration',
      key: 'dewDuration',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={HumidityIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.humidity}
        </span>
      ),
      dataIndex: 'humidity',
      key: 'humidity',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={DewIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.dewPoint}
        </span>
      ),
      dataIndex: 'dew',
      key: 'dew',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={NdviIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.plantNdvi}
        </span>
      ),
      dataIndex: 'ndvi',
      key: 'ndvi',
      className: styles.metricsTd,
    },
  ];
};

export const GetMetricsColumnsVegetation = (t) => {
  const MetricsLabels = getMetricsLabels(t);
  return [
    {
      title: () => <span className={styles.metricsTh}>{MetricsLabels.device}</span>,
      dataIndex: 'device',
      key: 'device',
      className: styles.metricsTd,
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={NdviIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.leafNdvi}
        </span>
      ),
      dataIndex: 'leafNdvi',
      key: 'leafNdvi',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={SoilNdviIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.soilNdvi}
        </span>
      ),
      dataIndex: 'soilNdvi',
      key: 'soilNdvi',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={LeafAreaIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.leafArea}
        </span>
      ),
      dataIndex: 'leafArea',
      key: 'leafArea',
      className: styles.metricsTd,
    },
    {
      title: () => (
        <span className={styles.metricsTh}>
          <figure className={styles.metricsThIcon}>
            <img src={PhotoNdviIcon} alt="" width="24" height="24" />
          </figure>
          {MetricsLabels.photoNdvi}
        </span>
      ),
      dataIndex: 'ndvi',
      key: 'ndvi',
      className: styles.metricsTd,
    },
  ];
};

export const GenerateNdviTicks = (minValue, maxValue, countNumbers) => {
  if (minValue === 0 || maxValue === 0) return [0];

  if (minValue === maxValue) {
    return [0, minValue, minValue * 2];
  }

  const count = countNumbers < 2 ? 2 : countNumbers;

  const minTick = Math.floor(minValue / 10) * 10;
  const maxTick = Math.ceil(maxValue / 10) * 10;

  const step = Math.ceil((maxTick - minTick) / (count - 1) / 10) * 10;

  return Array.from({ length: count }, (_, i) => minTick + i * step);
};
